<template>
  
  <div id="act_wrapper" >
    <div v-if="act_section" 
      class="min-vh-100 bg-img position-relative bg-lazy" 
      v-lazy:background-image="act_section[0].value.background_image.url_resized_large">

      <h2 class="text-center pt-3">
        <span class="guide-text-header px-3 py-1 ">{{ $t(iKey('act_section', 'act_section', 'label')) }}</span>        
      </h2>

      <h2 class="sr-only">
        <span v-for="(s, index) in act_section[0].value.statements" :key="index">{{ $t(iKey('act_section', 'act_section', 'statement_' + index)) }}</span>
      </h2>

      <div class="statement-wrapper d-flex justify-content-center align-items-center min-vh-100 vh-100 vw-100">
        
        <transition-group tag="div" class="statement-list d-flex justify-content-center" name="list">
          <ActStatement aria-hidden="true" v-for="(i) in statements" 
            class="list-item"
            :key="i.index"
            :item="i.value" 
            :index="i.index"></ActStatement>
        </transition-group>
      </div>

    </div>
  </div>
  
</template>

<script>
import ActStatement from '@/components/act/ActStatement'

export default {
  name: 'Act',
  data: () => {
    return {
      statements: [],
      intervalId: null
    }
  },
  props: [
    'act_section'
  ],
  components: {
    ActStatement
  },
  computed: {
    sectionData() {
      return this.act_section[0].value
    }
  },
  methods: {
    startStatementLoop() {
      let i = 1
      let sectionVal = this.$props.act_section[0].value
      this.endStatementLoop();
      this.$data.statements.push({'index': 0, 'value': sectionVal.statements[0]})
      
      this.$data.intervalId = setInterval(() => {
        if(i === 3){
          i = 0
          this.$data.statements = []
        } else {
          if(this.$data.statements.length == 1){
            this.$data.statements.pop(0)
          } else {
            this.$data.statements.push(
              {'index': i, 'value': sectionVal.statements[i]}
            )
            i++;
          }
        }
      }, 1800)
    },
    endStatementLoop() {
      this.$data.statements = []
      if(this.$data.intervalId){
        clearInterval(this.$data.intervalId)
      }
    }
  },
  mounted() {
      var dur = this.windowHeight * 2
      const scene = this.$scrollmagic.scene({
          triggerElement: '#act_wrapper',
          offset: '-50px',
          triggerHook: 0,
          duration: dur
      })
      this.$scrollmagic.addScene(
      scene
          .on("enter", () => {
            this.startStatementLoop()
          })
          .on("leave", () => {
            this.endStatementLoop()
          })
          //.addIndicators()
      )
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.guide-text-header {
  background-color: #00b0a8;
  color: #ffffff;
}
.bg-img {
   background-size: cover;
   background-position: center;
}

.statement-wrapper {
  position: absolute;
  top: 0;
  left: 0;
}
.statement-list {
  position: relative;
  width: 100%;
  height: 20vh;
  left: 0;
}
.list-item {
  position: absolute;
  width: 40%;
  backface-visibility: hidden;
}

.list-enter-active {
  transition: all 0.3s;
}
.list-leave-active {
  transition: all 0.3s ease 0.8s;
}

.list-enter,
.list-leave-to {
  opacity: 0;
}
.list-enter {
  margin-top: 100px;
}
.list-leave-to {
  margin-top: -100px;
}

</style>
